import {takeEvery} from 'redux-saga/effects'
import {
  ADD_FILE_TYPE,
  DELETE_MANY_FILE_TYPES,
  DELETE_SINGLE_FILE_TYPE,
  FILE_TYPE_USAGE,
  GET_ALL_FILE_TYPES,
  GET_FILE_TYPES_FOR_CONTEXT,
  UPDATE_FILE_TYPE,
  VIEW_SELECTED_FILE_TYPE,
} from 'setup/redux/Actions/FileType/ActionTypes/ApiActionTypes'

import fetchData from '../../SagaHelper'

function* dataSaga() {
  yield takeEvery(GET_ALL_FILE_TYPES, fetchData)
  yield takeEvery(GET_FILE_TYPES_FOR_CONTEXT, fetchData)
  yield takeEvery(ADD_FILE_TYPE, fetchData)
  yield takeEvery(DELETE_SINGLE_FILE_TYPE, fetchData)
  yield takeEvery(FILE_TYPE_USAGE, fetchData)
  yield takeEvery(DELETE_MANY_FILE_TYPES, fetchData)
  yield takeEvery(UPDATE_FILE_TYPE, fetchData)
  yield takeEvery(VIEW_SELECTED_FILE_TYPE, fetchData)
}

export default dataSaga
